"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChallengeCardProgressionHighlight = ChallengeCardProgressionHighlight;
var _Box2 = _interopRequireDefault(require("@mui/material/Box"));
var _LinearProgress2 = _interopRequireDefault(require("@mui/material/LinearProgress"));
var _Typography2 = _interopRequireDefault(require("@mui/material/Typography"));
var _Skeleton2 = _interopRequireDefault(require("@mui/material/Skeleton"));
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _hooks = require("../../hooks");
var _icons = require("../icons");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ChallengeCardProgressionHighlight({
  challenge,
  enableUserProgression,
  userChallenge,
  teamLeaderboard
}) {
  const {
    toOrdinal
  } = (0, _hooks.useUnits)();
  const {
    getProgressValue,
    getFormattedProgressValue
  } = (0, _hooks.useChallenge)();
  if (userChallenge === null) return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  if (challenge && (challenge.period === 'future' || challenge.collaborationType !== 'global' && !enableUserProgression)) return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  if (!challenge || challenge.targetValue && challenge.collaborationType === 'global') {
    return /*#__PURE__*/_react.default.createElement(_Box2.default, {
      bgcolor: "#ECFBF4",
      borderRadius: 2,
      display: "flex",
      flexDirection: "column",
      flexShrink: 0,
      gap: 1,
      marginTop: 1,
      padding: 2
    }, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
      variant: "body2"
    }, challenge ? getFormattedProgressValue(challenge, {
      highlight: true
    }) : /*#__PURE__*/_react.default.createElement(_Skeleton2.default, {
      variant: "text",
      width: "100"
    })), challenge ? /*#__PURE__*/_react.default.createElement(_LinearProgress2.default, {
      sx: {
        height: 8,
        '.MuiLinearProgress-bar': {
          bgcolor: '#2AC682'
        }
      },
      title: `${challenge.progressPercentage} %`,
      value: challenge.progressPercentage,
      variant: "determinate"
    }) : /*#__PURE__*/_react.default.createElement(_Skeleton2.default, {
      height: 8,
      variant: "rounded",
      width: "100%"
    }));
  }
  const displayTeamProgression = challenge.collaborationType === 'teams';
  return /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "center",
    bgcolor: userChallenge ? '#FFF5D0' : '#efefef',
    borderRadius: 2,
    display: "flex",
    flexDirection: "row",
    flexShrink: 0,
    gap: 1,
    marginTop: 1,
    padding: 2
  }, /*#__PURE__*/_react.default.createElement(_icons.CupIcon, {
    fontSize: "small",
    sx: {
      color: userChallenge ? '#EBAF25' : 'rgba(0, 0, 0, 0.54)'
    }
  }), /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    variant: "body2"
  }, userChallenge ? /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    components: [/*#__PURE__*/_react.default.createElement("span", {
      key: 0,
      style: {
        fontWeight: 700
      }
    })],
    context: displayTeamProgression ? 'team' : '',
    count: displayTeamProgression ? undefined : challenge.nbMembers,
    i18nKey: "commons.challenges.rank",
    values: displayTeamProgression ? {
      rank: teamLeaderboard ? toOrdinal(teamLeaderboard.rank, {
        feminine: true
      }) : '-',
      count: teamLeaderboard?.countSubgroupOfSameType || '-'
    } : {
      rank: userChallenge.rank !== undefined ? toOrdinal(userChallenge.rank, {
        inclusive: true
      }) : '-',
      count: challenge.nbMembers,
      progress: getProgressValue(challenge.type, userChallenge.progressValue)
    }
  }) : /*#__PURE__*/_react.default.createElement(_Skeleton2.default, {
    variant: "text",
    width: 100
  })));
}